export default __webpack_public_path__ + "static/media/00.db795157.jpg";